import React from 'react';

// CSS filters to color black icons; drop-shadow adds thickness
const YELLOW_ICON_FILTER = 'invert(72%) sepia(48%) saturate(500%) hue-rotate(5deg)';
const LIGHT_YELLOW_ICON_FILTER = 'invert(1) sepia(1) saturate(6) hue-rotate(15deg) brightness(1.15)';
const THICKEN_SHADOW = ' drop-shadow(0 0 1.2px rgba(255, 255, 0, 0.95)) drop-shadow(0 0 0.8px rgba(255, 255, 0, 0.9))';

export default function IconBoxStyle11({ title, subTitle, iconSrc, iconColor, textColor }) {
  const iconFilter =
    iconColor === 'lightYellow' ? LIGHT_YELLOW_ICON_FILTER + THICKEN_SHADOW
    : (iconColor === 'yellow' || iconColor === '#c9a227') ? YELLOW_ICON_FILTER
    : undefined;
  const iconStyle = { width: '40px', height: '40px', ...(iconFilter && { filter: iconFilter }) };
  const textStyle = textColor ? { color: textColor } : undefined;

  return (
    <div className="cs_iconbox cs_style_11 cs_radius_25" style={{
      // height: '100%',
      minHeight: '80px',
      display: 'flex',
      alignItems: 'center',
      padding: '14px 16px',
      width: '100%'
    }}>
      <div className="cs_iconbox_icon" style={{
        flexShrink: 0,
        marginRight: '12px'
      }}>
        <img src={iconSrc} alt="Icon" style={iconStyle} />
      </div>
      <div className="cs_iconbox_right" style={{
        flex: 1,
        minWidth: 0
      }}>
        <h3 className="cs_iconbox_title cs_fs_24 mb-0" style={{ 
          fontSize: '20px',
          marginBottom: '8px',
          wordWrap: 'break-word',
          ...textStyle
        }}>
          {title}
        </h3>
        <p className={`cs_iconbox_subtitle mb-0 ${!textColor ? 'cs_heading_color' : ''}`} style={{ 
          fontSize: '14px',
          lineHeight: '1.5',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          ...(textStyle || {})
        }}>
          {subTitle}
        </p>
      </div>
    </div>
  );
}
